(()=>{
  const ready=fn=>document.readyState==="loading"
    ? document.addEventListener("DOMContentLoaded",fn,{once:true})
    : fn();

  ready(()=>{
    const form=document.querySelector('form[data-type="add-to-cart-form"]');
    if(!form)return;

    const optionGroups=[...form.querySelectorAll("[data-swatch-option]")];
    const optionName=group=>[
      group.className||"",
      group.getAttribute("data-option-name")||"",
      group.querySelector(".t4s-swatch__title")?.textContent||""
    ].join(" ").toLowerCase();
    const sizeOption=optionGroups.find(group=>
      /bedding[\s_-]*size|select[\s_-]*size|mattress[\s_-]*size|name__(?:bedding-size|select-size|mattress-size|size)|(^|\s)size(\s|$)/.test(optionName(group))
    );
    const sizeItems=sizeOption?[...sizeOption.querySelectorAll("[data-swatch-item][data-value]")]:[];

    const atc=form.querySelector('button[type="submit"][name="add"],button[data-atc-form],button[type="submit"]');
    if(!atc)return;

    let handle="";
    try{
      handle=decodeURIComponent(location.pathname.split("/products/")[1]?.split("/")[0]||"");
    }catch{
      handle=location.pathname.split("/products/")[1]?.split("/")[0]||"";
    }
    const directAddHandles=new Set([
      "brooklyn-bedding-aurora-luxe-cooling-mattress",
      "sealy-posturepedic®-pro-hybrid-lacey-ii-13-firm-mattress",
      "stearns-foster-estate-13-5-extra-firm-mattress"
    ]);
    const allowDirectAdd=directAddHandles.has(handle);

    const bar=document.createElement("div");
    bar.className="tx-mobile-purchase";
    bar.setAttribute("role","region");
    bar.setAttribute("aria-label","Purchase options");
    bar.innerHTML='<div class="tx-mobile-purchase__copy"><span class="tx-mobile-purchase__title"></span><span class="tx-mobile-purchase__selection"></span></div><button type="button" class="tx-mobile-purchase__button" data-tx-event="mobile_sticky_purchase">Choose options</button>';
    document.body.appendChild(bar);
    document.body.classList.add("tx-has-mobile-purchase");

    const title=(document.querySelector("main h1")||document.querySelector("h1"))?.textContent?.trim()||"This mattress";
    bar.querySelector(".tx-mobile-purchase__title").textContent=title;
    const selection=bar.querySelector(".tx-mobile-purchase__selection");
    const action=bar.querySelector(".tx-mobile-purchase__button");

    const selectedSize=()=>{
      const selected=sizeItems.find(item=>
        item.classList.contains("is--selected")||
        item.classList.contains("is-selected")||
        item.getAttribute("aria-checked")==="true"||
        item.getAttribute("aria-pressed")==="true"
      );
      return selected?.dataset.value||sizeOption?.querySelector("[data-current-value]")?.textContent?.trim()||"";
    };
    const canAdd=()=>allowDirectAdd&&!atc.disabled&&!/sold out|unavailable/i.test(atc.textContent||"");

    function updatePurchaseBar(){
      const summary=form.querySelector(".tx-selection-summary,[class*='selection-summary']");
      selection.textContent=summary?.textContent?.trim()||selectedSize()||"Select size and options";
      action.textContent=canAdd()?"Add selected mattress":"Choose options";
      action.setAttribute("aria-label",canAdd()?"Add the selected mattress to cart":"Choose mattress options");
    }

    updatePurchaseBar();
    action.addEventListener("click",()=>{
      if(canAdd()){
        atc.click();
        return;
      }
      (sizeOption||atc).scrollIntoView({
        behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",
        block:"center"
      });
      (sizeOption?.querySelector("button,[tabindex='0']")||atc).focus({preventScroll:true});
    });

    if("IntersectionObserver" in window){
      const observer=new IntersectionObserver(entries=>{
        bar.classList.toggle("is-visible",!entries[0].isIntersecting&&window.scrollY>240);
      },{threshold:.1});
      observer.observe(atc);
    }

    form.addEventListener("change",()=>window.setTimeout(updatePurchaseBar,80));
    form.addEventListener("click",event=>{
      if(event.target.closest("[data-swatch-item]"))window.setTimeout(updatePurchaseBar,80);
    });
    new MutationObserver(updatePurchaseBar).observe(atc,{attributes:true,childList:true,subtree:true});
  });
})();
